import React from 'react';
import { Menu, X } from 'lucide-react';

interface HeaderProps {
  title: string;
  onMenuToggle: () => void;
}

const Header = ({ title, onMenuToggle }: HeaderProps) => {
  const franchiseName = localStorage.getItem("franquia") || "Matriz";

  return (
    <header className="bg-card border-b border-border sticky top-0 z-30">
      <div className="flex items-center justify-between px-4 py-4">
        <div className="flex items-center gap-3">
          <button
            onClick={onMenuToggle}
            className="lg:hidden p-2 hover:bg-muted rounded-lg transition-colors"
          >
            <Menu className="w-5 h-5" />
          </button>
          <div className="lg:hidden flex flex-col">
            <div className='flex items-center'>
              <img
                src="/v2/logos/logo-mini.png"
                alt="Logo X do Infinito"
                className="w-8 h-8 object-contain mr-2"
              />
              <h2 className='font-bold text-primary'>X do Infinito - {franchiseName}</h2>
            </div>
          </div>
        </div>
        
        {/* <div className="flex items-center gap-2">
          <button className="p-2 hover:bg-muted rounded-lg transition-colors">
            <X className="w-5 h-5 text-muted-foreground" />
          </button>
        </div> */}
      </div>
    </header>
  );
};

export default Header;